import { Pipe, PipeTransform } from '@angular/core';

const colors = {
  success: '#82B371',
  warning: '#E8BB7D',
  danger: '#DB7073'
};

@Pipe({
  name: 'indexColor'
})
export class IndexColorPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    const numberValue = Number(value);
    const isRaw = args?.[0] === 'raw';

    let key = null;
    if (numberValue > (2 / 3)) {
      key = 'success';
    } else if (numberValue > (1 / 3)) {
      key = 'warning';
    } else if (numberValue > 0) {
      key = 'danger';
    } else {
      return isRaw ? '#000000' : '';
    }

    return isRaw ? colors[key] : `ion-color-${key}`;
  }
}
